module.exports = __webpack_public_path__ + "img/ok.45e455f8.png";